import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import '../App.css'; 
import { WEBSERVICE_IP } from '../functions/roots/webserviceIP'; 

const Recuperarc = () => {
  const [correo, setCorreo] = useState('');
  const [nuevaContrasena, setNuevaContrasena] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [mostrarFormularioContrasena, setMostrarFormularioContrasena] = useState(false);
  const { token } = useParams(); // Usamos useParams para obtener el token de la URL
  const navigate = useNavigate();

  // Enviar correo para solicitar recuperación
  const handleEnviarCorreo = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${WEBSERVICE_IP}/usuarios/solicitar-recuperacion`, { correo: correo });
      setMensaje(response.data.mensaje);
      setMostrarFormularioContrasena(true); // Cambia a formulario de restablecimiento
    } catch (error) {
      setMensaje('Hubo un problema al enviar el correo. Intenta más tarde.');
      console.error(error);
    }
  };

  // Restablecer contraseña
  const handleRestablecerContrasena = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(
        `${WEBSERVICE_IP}/usuarios/restablecer`,
        { nuevaContrasena },
        {
          headers: {
            Authorization: `Bearer ${token}`, 
          },
        }
      );
      setMensaje(response.data.mensaje);
      if (response.data.mensaje === 'Contraseña restablecida con éxito.') {
        // Si la contraseña se restablece correctamente, redirigir al login
        setTimeout(() => {
          navigate('/inicio-sesion'); // Redirige al login después de 2 segundos
        }, 2000);
      }
    } catch (error) {
      setMensaje('Hubo un problema al restablecer la contraseña. Intenta más tarde.');
      console.error(error);
    }
  };

  // Mostrar el formulario de restablecimiento si el token está presente
  useEffect(() => {
    if (token) {
      setMostrarFormularioContrasena(true); // Si hay un token, mostramos el formulario de restablecimiento
    }
  }, [token]);

  return (
    <div className="recuperarc-background">
      <div className="recuperarc-container">
        <h2>Recuperación de Contraseña</h2>
        {!mostrarFormularioContrasena ? (
          <form onSubmit={handleEnviarCorreo}>
            <input
              type="email"
              placeholder="Ingresa tu correo electrónico"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              required
            /><br></br>
           <button type="submit" className="boton-recuperacion">Enviar</button>
          </form>
        ) : (
          <form onSubmit={handleRestablecerContrasena}>
            <input
              type="password"
              placeholder="Nueva contraseña"
              value={nuevaContrasena}
              onChange={(e) => setNuevaContrasena(e.target.value)}
              minLength={8} // Validación en el frontend
              required
            /><br></br>
           <button type="submit" className="boton-recuperacion">Restablecer</button>
          </form>
        )}
        {mensaje && <p>{mensaje}</p>}
      </div>
    </div>
  );
};

export default Recuperarc;